'use client';

import React from 'react';
import Link from 'next/link';
import { AlertTriangle, Plus, CheckCircle, Package } from 'lucide-react';

export default function DashboardHeader() {
  return (
    <div className="bg-card border-b border-border px-6 lg:px-8 xl:px-10 2xl:px-12 py-4">
      <div className="max-w-screen-2xl mx-auto flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-2xl font-700 text-foreground">Dashboard Operacional</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Quinta-feira, 17 de setembro de 2026 · Atualizado às 12:18
          </p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {/* Alert banner */}
          <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            <AlertTriangle size={14} className="text-red-600 shrink-0" />
            <span className="text-xs font-600 text-red-700">
              5 ordens em atraso crítico
            </span>
          </div>
          {/* Quick actions */}
          <Link
            href="/work-order-management"
            className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground text-sm font-600 px-3 py-2 rounded-lg hover:bg-primary/90 active:scale-95 transition-all duration-150 shadow-card"
          >
            <Plus size={15} />
            Nova OS
          </Link>
          <Link
            href="/work-order-management"
            className="inline-flex items-center gap-1.5 bg-amber-500 text-white text-sm font-600 px-3 py-2 rounded-lg hover:bg-amber-600 active:scale-95 transition-all duration-150 shadow-card"
          >
            <CheckCircle size={15} />
            Aprovar Pendentes (3)
          </Link>
          <Link
            href="/work-order-management"
            className="inline-flex items-center gap-1.5 bg-card border border-border text-foreground text-sm font-600 px-3 py-2 rounded-lg hover:bg-secondary active:scale-95 transition-all duration-150"
          >
            <Package size={15} />
            Ver Estoque
          </Link>
        </div>
      </div>
    </div>
  );
}